import {inject, Injectable, signal, WritableSignal} from '@angular/core';
import {AbstractMessageListenerService} from "./abstract-message-listener.service";
import {MatDialog} from "@angular/material/dialog";
import {openGuessResultDialog} from "../game/dialogs/guess-result-dialog/guess-result-dialog.component";
import {LobbyStore} from "../store/lobby.store";
import {LobbyType} from "../../backend/state/lobby-state.model";
import {GameStateStore} from "../store/game-state.store";
import {GuessResultMessage} from "../../backend/messages/guess-result.message";
import {toObservable} from "@angular/core/rxjs-interop";

const MOCKED_MESSAGE: GuessResultMessage = {
  "type": "guessResult",
  "results": [
    {
      "team": {
        "id": "36be0aa8-9978-4efd-a32c-7ee9a7dd0d2c",
        "name": "Team 1",
        "players": [
          {
            "id": "6f324c5f-feef-4283-962b-3a333e2a97f7",
            "name": "Cordelia",
            "connected": true
          }
        ]
      },
      "guess": {
        "guessIndex": 1,
        "minYear": 1940,
        "maxYear": 1950,
        "type": "DECADE",
        "guessOptions": [],
        "submitted": true
      },
      "correct": false
    }
  ]
} as any;

@Injectable({
  providedIn: 'root'
})
export class GuessResultMessageService extends AbstractMessageListenerService<GuessResultMessage> {
  readonly lobbyStore = inject(LobbyStore);
  readonly gameStore = inject(GameStateStore);

  private afterDialogClosed: WritableSignal<GuessResultMessage | undefined> = signal(undefined);

  public readonly afterDialogClosed$ = toObservable(this.afterDialogClosed);

  constructor(private dialog: MatDialog) {
    super('guessResult');
  }

  public override process(message: GuessResultMessage): void {
    let activeTeamResult;
    if (this.lobbyStore.type() === LobbyType.FREE_FOR_ALL) {
      activeTeamResult = message.results.find(result => result.team.id === this.lobbyStore.ownTeam()?.id);
    } else {
      activeTeamResult = message.results.find(result => result.team.id === this.gameStore.activeTeamId())
    }
    const orderedResults = message.results.sort((a, b) => a === activeTeamResult ? -1 : 0);
    openGuessResultDialog(this.dialog, {
      results: orderedResults,
      activeTeamResult
    }).afterClosed()
      .subscribe(() => {
        this.afterDialogClosed.set(message);
      });
  }
}
